import Paper from '@material-ui/core/Paper';
import React from 'react';
import { Component, NavigationActions } from '../../../client';
import { translate } from '../../../l10n';
import { LinkButton } from '../../ux/Buttons';

class PositionsEmptyPlaceholder extends Component {
   constructor(props) {
      super(props);
   }

   _onAddTeamClicked = () => {
      NavigationActions.to({ to: '/app/people/teams' });
   };

   render() {
      const { hasTeams } = this.props;

      const canAction = hasTeams;

      return (
         <div className={'PositionsEmptyPlaceholder'}>
            <Paper className={'info-box'} elevation={3}>
               <h2 className='heading'>{translate('positions.empty.title')}</h2>

               <div style={{ textAlign: 'center' }}>{translate('positions.empty.body')}</div>
               {!hasTeams && (
                  <p>
                     Start by
                     <LinkButton color='primary' onClick={this._onAddTeamClicked}>
                        defining teams
                     </LinkButton>
                     that the positions are a part of.
                  </p>
               )}
               {canAction && (
                  <p>
                     {translate('positions.empty.callToActionPrefix')}
                     <b> {translate('positions.empty.callToActionButtonName')} </b>
                     {translate('positions.empty.callToActionSuffix')}
                  </p>
               )}
            </Paper>
         </div>
      );
   }
}

export default PositionsEmptyPlaceholder;
